export const TRANSFER_STATUS_KIND_PENDING = {
    "id": "f6e1b917-db83-49f3-8605-081788d27952",
    "transfer_status_name": "Oczekuje",
    "transfer_status_kind": "pending",
}

export const TRANSFER_STATUS_KIND_PARTIAL_PAYMENT =     {
    "id": "1879a6c0-f83c-4435-ae22-d44e128dac3d",
    "transfer_status_name": "Częściowa płatność",
    "transfer_status_kind": "partial_payment",
}

export const TRANSFER_STATUS_KIND_PAID = {
    "id": "80da13f2-7858-4955-ad84-43ea540fc4fb",
    "transfer_status_name": "Zapłacono",
    "transfer_status_kind": "paid",
}

export const TRANSFER_STATUS_KIND_EXCESS_PAYMENT = {
        "id": "b4f09f0e-8908-46d2-966c-062e1d603938",
        "transfer_status_name": "Nadpłata",
        "transfer_status_kind": "excess_payment",
}

export const TRANSFER_STATUS_KIND_PAID_CANCELED = {
        "id": "ba424574-3887-493a-9ea4-1cbca10b274d",
        "transfer_status_name": "Zapłacona/anulowana",
        "transfer_status_kind": "paid_canceled",
}

export const TRANSFER_STATUS_KIND_REBOOKED = {
        "id": "cb534f58-fd10-4cb4-a76b-345f7dcd56ee",
        "transfer_status_name": "Przeksięgowana",
        "transfer_status_kind": "rebooked",
}

export const TRANSFER_STATUS_KIND_PAID_CONNECTED = {
        "id": "36f8eeec-eda9-4ae5-87b1-97c3a5ee44cf",
        "transfer_status_name": "Połączono",
        "transfer_status_kind": "connected",
}

export const TRANSFER_STATUS_KIND_PAID_NOT_CONNECTED = {
        "id": "3f256137-0857-45d3-99f7-fd71aac6a104",
        "transfer_status_name": "Nie Połączono",
        "transfer_status_kind": "not_connected",
}

export const TRANSFER_STATUS_KINDS = [
    TRANSFER_STATUS_KIND_PENDING,
    TRANSFER_STATUS_KIND_PARTIAL_PAYMENT,
    TRANSFER_STATUS_KIND_PAID,
    TRANSFER_STATUS_KIND_EXCESS_PAYMENT,
    TRANSFER_STATUS_KIND_PAID_CANCELED,
    TRANSFER_STATUS_KIND_PAID_CONNECTED,
    TRANSFER_STATUS_KIND_PAID_NOT_CONNECTED
];